const AUTH_SESSION_CHANGED_EVENT = 'wearoclub-auth-session-changed';

const dispatchAuthSessionChanged = () => {
  window.dispatchEvent(new Event(AUTH_SESSION_CHANGED_EVENT));
};

export const getStoredUser = () => {
  const userData = localStorage.getItem('user');
  const token = localStorage.getItem('token');

  if (!userData || !token) {
    if (userData && !token) {
      localStorage.removeItem('user');
    }
    return null;
  }

  try {
    return JSON.parse(userData);
  } catch (error) {
    console.error('Failed to parse stored user:', error);
    localStorage.removeItem('user');
    return null;
  }
};

export const setSession = ({ token, refreshToken, user }) => {
  localStorage.setItem('token', token);
  localStorage.setItem('refresh_token', refreshToken);
  localStorage.setItem('user', JSON.stringify(user));
  dispatchAuthSessionChanged();
};

export const clearSession = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('refresh_token');
  localStorage.removeItem('user');
  dispatchAuthSessionChanged();
};

export const subscribeToAuthSession = (callback) => {
  const handleSessionChange = () => {
    callback(getStoredUser());
  };

  window.addEventListener(AUTH_SESSION_CHANGED_EVENT, handleSessionChange);
  window.addEventListener('storage', handleSessionChange);

  return () => {
    window.removeEventListener(AUTH_SESSION_CHANGED_EVENT, handleSessionChange);
    window.removeEventListener('storage', handleSessionChange);
  };
};
